import { render } from "./SignatureBlockPopup.vue?vue&type=template&id=ff99c6aa&scoped=true"
import script from "./SignatureBlockPopup.vue?vue&type=script&lang=js"
export * from "./SignatureBlockPopup.vue?vue&type=script&lang=js"

import "./SignatureBlockPopup.vue?vue&type=style&index=0&id=ff99c6aa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff99c6aa"]])

export default __exports__